import { render, staticRenderFns } from "./chatPush.vue?vue&type=template&id=45541583&scoped=true&"
import script from "./chatPush.vue?vue&type=script&lang=js&"
export * from "./chatPush.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45541583",
  null
  
)

export default component.exports